// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GraphqlTag from "graphql-tag";

var Raw = {};

var query = GraphqlTag.gql(["fragment MenuFragment on AcademyMenuNode   {\n__typename  \nid  \ntitle  \ndescription  \nhasActivities  \nparentId  \n}\n"]);

function parse(value) {
  var value$1 = value.description;
  return {
          __typename: value.__typename,
          id: value.id,
          title: value.title,
          description: !(value$1 == null) ? value$1 : undefined,
          hasActivities: value.hasActivities,
          parentId: value.parentId
        };
}

function serialize(value) {
  var value$1 = value.parentId;
  var value$2 = value.hasActivities;
  var value$3 = value.description;
  var description = value$3 !== undefined ? value$3 : null;
  var value$4 = value.title;
  var value$5 = value.id;
  var value$6 = value.__typename;
  return {
          __typename: value$6,
          id: value$5,
          title: value$4,
          description: description,
          hasActivities: value$2,
          parentId: value$1
        };
}

function verifyArgsAndParse(_MenuFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var MenuFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

var Raw$1 = {};

var query$1 = GraphqlTag.gql(["fragment ActivityFragment on AcademyActivity   {\n__typename  \nid  \ntitle  \nmenuNodeId  \nresult  {\n__typename  \nacademyActivityId  \nkind  \ncontentKind  \nbestScoreNumComplete  \nbestScoreNumCorrect  \nbestResponsesScore  \nhasResponsesScore  \nstarted  \n}\n\n}\n"]);

function parse$1(value) {
  var value$1 = value.result;
  var value$2 = value$1.contentKind;
  var tmp;
  switch (value$2) {
    case "audio" :
        tmp = "audio";
        break;
    case "custom_word_list" :
        tmp = "custom_word_list";
        break;
    case "example_sentence" :
        tmp = "example_sentence";
        break;
    case "monster_chef" :
        tmp = "monster_chef";
        break;
    case "not_set" :
        tmp = "not_set";
        break;
    case "phonics" :
        tmp = "phonics";
        break;
    case "sound_train" :
        tmp = "sound_train";
        break;
    case "tupperware" :
        tmp = "tupperware";
        break;
    case "video" :
        tmp = "video";
        break;
    case "whack_a_munk" :
        tmp = "whack_a_munk";
        break;
    case "word" :
        tmp = "word";
        break;
    case "word_list" :
        tmp = "word_list";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$2
      };
  }
  var value$3 = value$1.bestResponsesScore;
  return {
          __typename: value.__typename,
          id: value.id,
          title: value.title,
          menuNodeId: value.menuNodeId,
          result: {
            __typename: value$1.__typename,
            academyActivityId: value$1.academyActivityId,
            kind: value$1.kind,
            contentKind: tmp,
            bestScoreNumComplete: value$1.bestScoreNumComplete,
            bestScoreNumCorrect: value$1.bestScoreNumCorrect,
            bestResponsesScore: !(value$3 == null) ? value$3 : undefined,
            hasResponsesScore: value$1.hasResponsesScore,
            started: value$1.started
          }
        };
}

function serialize$1(value) {
  var value$1 = value.result;
  var value$2 = value$1.started;
  var value$3 = value$1.hasResponsesScore;
  var value$4 = value$1.bestResponsesScore;
  var bestResponsesScore = value$4 !== undefined ? value$4 : null;
  var value$5 = value$1.bestScoreNumCorrect;
  var value$6 = value$1.bestScoreNumComplete;
  var value$7 = value$1.contentKind;
  var contentKind = typeof value$7 === "object" ? value$7.VAL : (
      value$7 === "not_set" ? "not_set" : (
          value$7 === "example_sentence" ? "example_sentence" : (
              value$7 === "word" ? "word" : (
                  value$7 === "word_list" ? "word_list" : (
                      value$7 === "whack_a_munk" ? "whack_a_munk" : (
                          value$7 === "phonics" ? "phonics" : (
                              value$7 === "sound_train" ? "sound_train" : (
                                  value$7 === "tupperware" ? "tupperware" : (
                                      value$7 === "monster_chef" ? "monster_chef" : (
                                          value$7 === "audio" ? "audio" : (
                                              value$7 === "video" ? "video" : "custom_word_list"
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
  var value$8 = value$1.kind;
  var value$9 = value$1.academyActivityId;
  var value$10 = value$1.__typename;
  var result = {
    __typename: value$10,
    academyActivityId: value$9,
    kind: value$8,
    contentKind: contentKind,
    bestScoreNumComplete: value$6,
    bestScoreNumCorrect: value$5,
    bestResponsesScore: bestResponsesScore,
    hasResponsesScore: value$3,
    started: value$2
  };
  var value$11 = value.menuNodeId;
  var value$12 = value.title;
  var value$13 = value.id;
  var value$14 = value.__typename;
  return {
          __typename: value$14,
          id: value$13,
          title: value$12,
          menuNodeId: value$11,
          result: result
        };
}

function verifyArgsAndParse$1(_ActivityFragment, value) {
  return parse$1(value);
}

function verifyName$1(param) {
  
}

var ActivityFragment = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  verifyArgsAndParse: verifyArgsAndParse$1,
  verifyName: verifyName$1
};

var Raw$2 = {};

var query$2 = GraphqlTag.gql(["fragment AcademyMatrixCategoryAggregateFragment on AcademyMatrixCategoryAggregate   {\n__typename  \ncategoryId  \navgBestCategoryAttempts  \navgLatestCategoryAttempts  \ntotalCategoryAttempts  \nuniqueActivityCount  \ntotalActivityCount  \n}\n"]);

function parse$2(value) {
  var value$1 = value.avgBestCategoryAttempts;
  var value$2 = value.avgLatestCategoryAttempts;
  var value$3 = value.totalCategoryAttempts;
  var value$4 = value.uniqueActivityCount;
  return {
          __typename: value.__typename,
          categoryId: value.categoryId,
          avgBestCategoryAttempts: !(value$1 == null) ? value$1 : undefined,
          avgLatestCategoryAttempts: !(value$2 == null) ? value$2 : undefined,
          totalCategoryAttempts: !(value$3 == null) ? value$3 : undefined,
          uniqueActivityCount: !(value$4 == null) ? value$4 : undefined,
          totalActivityCount: value.totalActivityCount
        };
}

function serialize$2(value) {
  var value$1 = value.totalActivityCount;
  var value$2 = value.uniqueActivityCount;
  var uniqueActivityCount = value$2 !== undefined ? value$2 : null;
  var value$3 = value.totalCategoryAttempts;
  var totalCategoryAttempts = value$3 !== undefined ? value$3 : null;
  var value$4 = value.avgLatestCategoryAttempts;
  var avgLatestCategoryAttempts = value$4 !== undefined ? value$4 : null;
  var value$5 = value.avgBestCategoryAttempts;
  var avgBestCategoryAttempts = value$5 !== undefined ? value$5 : null;
  var value$6 = value.categoryId;
  var value$7 = value.__typename;
  return {
          __typename: value$7,
          categoryId: value$6,
          avgBestCategoryAttempts: avgBestCategoryAttempts,
          avgLatestCategoryAttempts: avgLatestCategoryAttempts,
          totalCategoryAttempts: totalCategoryAttempts,
          uniqueActivityCount: uniqueActivityCount,
          totalActivityCount: value$1
        };
}

function verifyArgsAndParse$2(_AcademyMatrixCategoryAggregateFragment, value) {
  return parse$2(value);
}

function verifyName$2(param) {
  
}

var AcademyMatrixCategoryAggregateFragment = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  verifyArgsAndParse: verifyArgsAndParse$2,
  verifyName: verifyName$2
};

var Raw$3 = {};

var query$3 = GraphqlTag.gql([
      "fragment AcademyMatrixAggregateFragment on AcademyMatrixAggregate   {\n__typename  \nfirst  \nlast  \nstudentId  \ncategoryAggregates  {\n...AcademyMatrixCategoryAggregateFragment   \n}\n\n}\n",
      ""
    ], query$2);

function parse$3(value) {
  var value$1 = value.categoryAggregates;
  return {
          __typename: value.__typename,
          first: value.first,
          last: value.last,
          studentId: value.studentId,
          categoryAggregates: value$1.map(function (value) {
                return parse$2(value);
              })
        };
}

function serialize$3(value) {
  var value$1 = value.categoryAggregates;
  var categoryAggregates = value$1.map(function (value) {
        return serialize$2(value);
      });
  var value$2 = value.studentId;
  var value$3 = value.last;
  var value$4 = value.first;
  var value$5 = value.__typename;
  return {
          __typename: value$5,
          first: value$4,
          last: value$3,
          studentId: value$2,
          categoryAggregates: categoryAggregates
        };
}

function verifyArgsAndParse$3(_AcademyMatrixAggregateFragment, value) {
  return parse$3(value);
}

function verifyName$3(param) {
  
}

var AcademyMatrixAggregateFragment = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  verifyArgsAndParse: verifyArgsAndParse$3,
  verifyName: verifyName$3
};

export {
  MenuFragment ,
  ActivityFragment ,
  AcademyMatrixCategoryAggregateFragment ,
  AcademyMatrixAggregateFragment ,
}
/* query Not a pure module */
